module.exports = __webpack_public_path__ + "img/contacts-black.5dbbc9d5.png";